// As rotas dos lembretes das notas (passo 18, PR 2). O caminho NUNCA leva `/api/v1` (o VITE_API_URL já o traz).
// Arquivo próprio (e não `chatService`): os testes da ChatPage não precisam saber dele.
import api from "./api";
import type { Lembrete, PaginaDeConcluidos, PainelDeLembretes } from "@/types/chat";

const lembretesService = {
  /** Marca ou muda a hora (PUT; 200 nos dois casos). */
  marcar: async (messageId: string, lembrarEm: string) => {
    const r = await api.put<Lembrete>(`/chat/messages/${messageId}/lembrete`, {
      lembrar_em: lembrarEm,
    });
    return r.data;
  },
  /** Cancela (204; idempotente). */
  cancelar: async (messageId: string) => {
    await api.delete(`/chat/messages/${messageId}/lembrete`);
  },
  concluir: async (lembreteId: string) => {
    const r = await api.post<Lembrete>(`/chat/lembretes/${lembreteId}/concluir`);
    return r.data;
  },
  adiar: async (lembreteId: string) => {
    const r = await api.post<Lembrete>(`/chat/lembretes/${lembreteId}/adiar`);
    return r.data;
  },
  painel: async () => {
    const r = await api.get<PainelDeLembretes>(`/chat/notas/lembretes`);
    return r.data;
  },
  /** Os 20 concluídos anteriores a `antes` (o `concluido_em` do último que a tela mostra). */
  concluidosAntes: async (antes: string) => {
    const r = await api.get<PaginaDeConcluidos>(`/chat/notas/lembretes/concluidos`, {
      params: { antes },
    });
    return r.data;
  },
};

export default lembretesService;
